
import { useUserRole } from "@/hooks/useUserRole";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import { AdminFeedbackManagement } from "@/components/admin/AdminFeedbackManagement";

const AdminFeedback = () => {
  const { user } = useAuth();
  const { isAdmin, loading: roleLoading } = useUserRole();

  // Show loading while checking role
  if (roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-10 w-10 animate-spin text-primary" />
          <p className="text-lg font-medium text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect non-admins to homepage
  if (!user || !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="font-poppins font-bold text-4xl mb-4 text-foreground">Feedback Management</h1>
          <p className="font-inter text-xl text-muted-foreground">
            Review and respond to user feedback submissions
          </p>
        </div>

        <AdminFeedbackManagement />
      </div>
    </div>
  );
};

export default AdminFeedback;
